import React from 'react';
import "./onboard-total-qouta-style.scss";
import {useTranslation} from "react-i18next";
import loadingImg from "../../../assets/images/loading-load-sv.svg";

const OnboardTotalQouta = (props) => {
    const {t} = useTranslation();
    const {
        black,
        qoutaRemainingTime,
        qoutaRemainingMB,
        qoutaRemainingTotalMB,
        isUnlimitedInternet,
        isUnlimitedMessage,
        loading
    } = props;

    const renderQouta = () => {
        return (
            <div className={"onboard-total-qouta-root "
                + (black ? 'onboard-total-qouta-root-black ' : 'onboard-total-qouta-root-red ')}>
                <p className="onboard-total-qouta-title">{
                    isUnlimitedMessage && qoutaRemainingTotalMB === 0 ?
                        t('home.your_rights') :
                        t('home.total_qouta_remaining')}</p>
                {isUnlimitedInternet && (
                    <p className="onboard-total-qouta-text">{t('purchase_package.network_package_unlimited')}</p>)}
                {!isUnlimitedInternet && !isUnlimitedMessage && qoutaRemainingMB === 0 && qoutaRemainingTotalMB === 0 && (
                    <p className="onboard-total-qouta-text">{qoutaRemainingMB} MB<span
                        style={{margin: '0 10px'}}>/</span>{qoutaRemainingTotalMB} MB</p>)}
                {!isUnlimitedInternet && isUnlimitedMessage && qoutaRemainingMB === "-" && (
                    <p className="onboard-total-qouta-text">{t('purchase_package.message_package_unlimited')}</p>)}
                {!isUnlimitedInternet && qoutaRemainingTotalMB !== 0 && qoutaRemainingMB !== "-" && (
                    <p className="onboard-total-qouta-text">{qoutaRemainingMB} MB<span
                        style={{margin: '0 10px'}}>/</span>{qoutaRemainingTotalMB} MB</p>)}
                {!isUnlimitedInternet && isUnlimitedMessage && qoutaRemainingTotalMB !== 0 && qoutaRemainingMB !== "-" && (
                    <p className="onboard-total-qouta-chat">+ {t('card_package.unlimited_messaging')}</p>)}
                {isUnlimitedMessage && qoutaRemainingTotalMB === 0 && qoutaRemainingMB !== "-" && (
                    <p className="onboard-total-qouta-text">{t('card_package.unlimited_messaging')}</p>)}
                {qoutaRemainingMB === "-" && !isUnlimitedInternet && !isUnlimitedMessage && (
                    <p className="onboard-total-qouta-text-error">{t('card_package.error_remaining_usage')}</p>)}
                {qoutaRemainingMB !== "-" && (
                    <p className="onboard-total-qouta-footer-info">{t('home.remaining_internet_package')}<br/></p>
                )}
            </div>
        )
    }

    return (
        <div>
            {loading ? (
                <div className={"onboard-total-qouta-root "
                    + (black ? 'onboard-total-qouta-root-black ' : 'onboard-total-qouta-root-red ')}>
                    <div className="onboard-total-qouta-loading">
                        <img className="onboard-total-qouta-loading-img" src={loadingImg} alt="loading..."/>
                    </div>
                </div>
            ) : renderQouta()}
        </div>
    )
};

export default OnboardTotalQouta;
